function scrolling_banners() {
  const $track = $('.promo-line-track');
  let position = 0;
  let speed = 1;
  let req;

  $track.find('a').clone().addClass('cloned').appendTo('.promo-line-track');

  function animate() {
    position += speed;
    req = requestAnimationFrame(animate);
    $track.css('transform', 'translateX(-' + position + 'px');

    const firstClone = $track.find('a.cloned').first();
    if (firstClone.offset() && firstClone.offset().left < 0) {
      position = 0;
    }
  }
  animate();

  $track.on('mouseenter', function () {
    cancelAnimationFrame(req);
  });

  $track.on('mouseleave', function () {
    animate();
  });

  $('.promo-line-close').on('click', function () {
    cancelAnimationFrame(req);
    $('.promo-line').remove();
  });
}
